export enum GiftCardType {
  GIFT_CARD = 'gift-card',
  EGIFT_CARD = 'egift-card',
}
